import React from 'react';
import Style from './Styles/SearchOrdersStyle';
import Settings from '../../../Settings/Settings'
import Paper from '@mui/material/Paper';
import InputBase from '@mui/material/InputBase';
import IconButton from '@mui/material/IconButton';
import SearchIcon from '@mui/icons-material/Search';
import Grid from '@mui/material/Grid';

export default function SearchOrdersComponent(props) {
    const classes = Style();

    const componentConstants = {
        ...props.componentConstants
    }

    const componentMethods = {
        ...props.componentMethods
    }
    
    let yourUrlParamsSearchQuery = ''
    if(componentConstants.urlParams && componentConstants.urlParams.query) {
      yourUrlParamsSearchQuery = componentConstants.urlParams.query
    }
    
    const [ordersQuery, setOrdersQuery] = React.useState(yourUrlParamsSearchQuery)

    const handleKeyPress = (event) => {
        if(event.key === 'Enter'){
          searchOrders(event)
        }
    }

    const searchOrders = (e) => {
        let endpoint = Settings.API_ENDPOINT_ORDERS
          if(ordersQuery) {
            componentMethods.changeRoute('/orders/' + ordersQuery)
              endpoint = Settings.API_ENDPOINT_ORDERS + '?q=' + ordersQuery+ "&accountToken=" + componentMethods.getLocalStorage('user').tokensHash
              componentMethods.getSearchOrders(endpoint)
          } else {
            componentMethods.changeRoute('/orders')
          }
      }

    return   <React.Fragment>
      <Grid item xs={1} lg={4} md={1}></Grid>
    <Grid item xs={10} lg={4} md={10}>
      <Paper component="form" style={classes.root}>
    <InputBase
      style={classes.input}
      placeholder={componentConstants.language.LANG_SEARCH_ORDERS + "..."}
      inputProps={{ 'aria-label': componentConstants.language.LANG_SEARCH_ORDERS + "..." }}
      value={ordersQuery} 
      onChange={(event)=>{ setOrdersQuery(event.target.value)}}
      onKeyPress={handleKeyPress}
    />
    <IconButton type="button" onClick={searchOrders} style={classes.iconButton} aria-label="search">
      <SearchIcon />
    </IconButton>
    </Paper> </Grid><Grid item xs={1} lg={4} md={1}></Grid>
    </React.Fragment>
}
